import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat';
const getDataPengajuanPenerbitanSertifikatBelumDiterima = 'data-pengajuan-penerbitan-sertifikat-belum-diterima'
const getDataPengajuanPenerbitanSertifikatAjuan = 'data-pengajuan-penerbitan-sertifikat-pengajuan'
const getDetailDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat/';
const putDataPengajuanPenerbitanSertifikat = 'data-pengajuan-penerbitan-sertifikat/';


class PengajuanPenerbitanSertifikatService {
    
    getData(currentPage,pageSize,filter,periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi,
        };
        
        return axios.get(
            API_URL + getDataPengajuanPenerbitanSertifikat ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getDataPengajuan(currentPage, pageSize, filter, periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi
        };
        
        return axios.get(API_URL + getDataPengajuanPenerbitanSertifikatAjuan, {
            params : data,
            headers: authHeader()
        });
        
    }

    getDataBelumDiterima(currentPage,pageSize,filter,periode, idSertifikasi) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            periode : periode,
            id_sertifikasi: idSertifikasi
        };
        
        return axios.get(
            API_URL + getDataPengajuanPenerbitanSertifikatBelumDiterima ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getDetailData(id_pengajuan_penerbitan) {        
        return axios
        .get(
            API_URL + getDetailDataPengajuanPenerbitanSertifikat + id_pengajuan_penerbitan,
            { headers: authHeader() }
        );
    }

    putJadwalTc(formData) {
         var form = new FormData();
         form.append("idKodePelatihan",formData.idKodePelatihan); 
         form.append("id_pengajuan_penerbitan",formData.id_pengajuan_penerbitan);
         form.append("kodeSertifikat",formData.kodeSertifikat);
         form.append("noSertifikat",formData.noSertifikat);
         form.append("keterangan",formData.keterangan);
         form.append("noResi",formData.noResi);
         if(typeof formData.suratKuasa !== 'undefined' || formData.suratKuasa !== undefined ) {
            form.append("suratKuasa",formData.suratKuasa);
        }
         form.append("statusPengajuan",formData.statusPengajuan);
         form.append("tanggalPengambilan",formData.tanggalPengambilan);
         form.append("statusPengambilan",formData.statusPengambilan);
        return axios
        .put(
            API_URL + putDataPengajuanPenerbitanSertifikat + formData.id_pengajuan_penerbitan, form,
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
        );
    }

}

export default new PengajuanPenerbitanSertifikatService();
